export default __webpack_public_path__ + "static/media/icon-unduh-new.96004fb0.svg";